import { Components, Theme } from '@mui/material/styles'

import { FIELD_HEIGHT } from 'components/UI/fieldMetrics'

export const MuiAutocomplete: Components<Theme>['MuiAutocomplete'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: 0,

      '.Mui-disabled': {
        backgroundColor: 'rgb(0 0 0 / 3%)',
      },
    }),

    inputRoot: ({ theme }) => ({
      fontSize: 16,
      fontWeight: 400,
      // The one field height (see `MuiInputBase.ts`). No live surface renders an
      // Autocomplete today — `components/Fields/SelectCountry` is the only
      // consumer and nothing imports it — so this is a dormant 44 rather than a
      // visible one, which is exactly why it is worth moving now: the next field
      // built on Autocomplete would otherwise arrive 4px taller than its
      // neighbours for no reason anyone could find.
      lineHeight: `${FIELD_HEIGHT}px`,
      padding: 0,
      height: `${FIELD_HEIGHT}px`,
      paddingLeft: '14px',
      //paddingRight: '70px',

      '&:focus': {
        backgroundColor: 'transparent',
      },

      '.Mui-disabled': {
        backgroundColor: 'transparent',
      },

      '.MuiInputBase-input': {
        padding: 0,
      },
    }),

    endAdornment: ({ theme }) => ({
      top: 'calc(50% - 12px)',
      right: '10px !important',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',

      '.MuiButtonBase-root': {
        display: 'flex',
        padding: 0,
        marginRight: 4,
        width: 24,
        height: 24,
      },

      '.MuiAutocomplete-popupIndicator': {
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },

      '.MuiAutocomplete-clearIndicator': {
        borderRadius: '50%',

        '.MuiSvgIcon-root': {
          width: 16,
          height: 16,
        },

        '&:hover': {
          '.MuiSvgIcon-root': {
            color: theme.palette.common.black,
          },
        },
      },

      '.MuiCircularProgress-root': {
        circle: {
          strokeWidth: 1,
        },
      },
    }),

    paper: ({ theme }) => ({
      borderRadius: 0,
      boxShadow:
        '0px 5px 5px -3px rgba(0, 0, 0, 0.20), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)',
      marginTop: '8px',
      marginBottom: '8px',
    }),

    noOptions: ({ theme }) => ({
      fontSize: 16,
      color: theme.palette.text.secondary,
    }),

    loading: ({ theme }) => ({
      fontSize: 16,
      color: theme.palette.text.secondary,
    }),

    listbox: ({ theme }) => ({}),

    option: ({ theme }) => ({ fontSize: 14 }),
  },
}
